export interface Integration {
  id: string;
  name: string;
  category: IntegrationCategory;
  description?: string;
  logoUrl?: string;
  isConnected: boolean;
  connectedAt?: string;
  lastSync?: string;
  status: IntegrationStatus;
  settings?: IntegrationSettings;
  user_integration_id?: string;
}

export enum IntegrationCategory {
  CRM = 'CRM',
  RMS = 'RMS',
  DocumentRepository = 'Document Repository',
  PortfolioManagement = 'Portfolio Management',
  Compliance = 'Compliance',
  MarketIntelligence = 'Market Intelligence',
  PublicDataSources = 'Public Data Sources',
  Security = 'Security',
  Collaboration = 'Collaboration',
  Documentation = 'Documentation',
  LLM = 'LLM',
  REIT = 'REIT',
  PublicClouds = 'Public Clouds',
  Productivity = 'Productivity'
}

export enum IntegrationStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Error = 'Error',
  Syncing = 'Syncing',
  ComingSoon = 'Coming Soon'
}

export interface IntegrationSettings {
  apiKey?: string;
  endpoint?: string;
  syncFrequency?: string;
  enabledFeatures?: string[];
  customFields?: Record<string, any>;
}
